import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { GetVersionTypesResponse } from "./GetVersionTypesResponse";

export const useCatalogueLookupsApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet } = useAuthorizedFetch();
    const baseUrl = appConfigContext.catalogueConfig.apiUrl;

    const getNonTrailerVersionTypes = async (): Promise<GetVersionTypesResponse> => {
        return httpGet<GetVersionTypesResponse>(`${baseUrl}/versions`);
    };

    const getTrailerVersionTypes = async (): Promise<GetVersionTypesResponse> => {
        return httpGet<GetVersionTypesResponse>(`${baseUrl}/trailer-versions`);
    };

    return {
        getNonTrailerVersionTypes,
        getTrailerVersionTypes
    };
};
